import request from '@/utils/request'


export function createSubscription(data) {
    const paymentMethod = data.paymentMethod || 'paypal';
    const planId = data.planId || 0;
    return request({
        url: `/api/${paymentMethod}-payment/create-subscription`,
        method: 'post',
        data:{planId}
    })
}

export function executeSubscription(data) {
    return request({
        url: `/api/paypal-payment/execute-subscription`,
        method: 'post',
        data
    })
}


export function cancelSubscription() {
    return request({
        url: `/api/paypal-payment/cancel-subscription`,
        method: 'post',
    })
}

export function createRecurringPayment(data) {
    return request({
        url: `/api/elavon-payment/create-subscription`,
        method: 'post',
        data
    })
}


